import React, { memo, useEffect } from 'react';
import { createDrawerNavigator } from '@react-navigation/drawer';
import {
  LinkPage,
  ProfilePage,
  ShopPage,
  ThemePage,
  GalleryPage,
  ResumePage,
  OrderPage,
  ReportPage,
} from '@redlink/components/pages';
import { DrawerIcon } from '@redlink/components/molecules';
import { LoadingContainer, useSupport } from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';
import { useValues } from '@redlink/assets/values';
import { useQuery, getUserProfileQuery } from '@redlink/services';
import { DashboardDrawer } from './dashboardDrawer';
import { useTooltip } from '@redlink/components/molecules';

const Drawer = createDrawerNavigator();

export const DashboardPage = memo(({ navigation }) => {
  const { dictionary } = useLocale();
  const { routes } = useValues();
  const { setNavigation } = useTooltip();

  useSupport();

  const {
    loading: getUserProfileIsBusy,
    data: { UserProfile: { isPageSelected, currentPage } = {} },
  } = useQuery(getUserProfileQuery, {
    failed: ({ code }) => {
      code === 4 && navigation.navigate(routes.registerWithPhone.key);
    },
    done: () => {
      if (!isPageSelected) navigation.navigate(routes.pages.key);
      else if (isPageSelected && currentPage.needToSetup)
        navigation.navigate(routes.pageLanguageSetup.key);
    },
  });

  useEffect(() => setNavigation(navigation), []);

  return (
    <LoadingContainer isInitial isBusy={getUserProfileIsBusy}>
      <DashboardDrawer {...{ Drawer }}>
        <Drawer.Screen
          name={routes.profile.key}
          component={ProfilePage}
          options={{
            drawerLabel: dictionary.profile,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.profile.name} {...props} />
            ),
          }}
        />
        <Drawer.Screen
          name={routes.link.key}
          component={LinkPage}
          options={{
            drawerLabel: dictionary.links,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.link.name} {...props} />
            ),
          }}
        />
        <Drawer.Screen
          name={routes.theme.key}
          component={ThemePage}
          options={{
            drawerLabel: dictionary.theme,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.theme.name} {...props} />
            ),
          }}
        />
        <Drawer.Screen
          name={routes.gallery.key}
          component={GalleryPage}
          options={{
            drawerLabel: dictionary.gallery,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.gallery.name} {...props} />
            ),
          }}
        />
        <Drawer.Screen
          name={routes.shop.key}
          component={ShopPage}
          options={{
            drawerLabel: dictionary.shop,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.shop.name} {...props} />
            ),
          }}
        />
        {/* <Drawer.Screen
          name={routes.order.key}
          component={OrderPage}
          options={{
            drawerLabel: dictionary.orders,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.order.name} {...props} />
            ),
          }}
        /> */}
        <Drawer.Screen
          name={routes.resume.key}
          component={ResumePage}
          options={{
            drawerLabel: dictionary.resume,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.resume.name} {...props} />
            ),
          }}
        />
        <Drawer.Screen
          name={routes.report.key}
          component={ReportPage}
          options={{
            drawerLabel: dictionary.dashboard,
            drawerIcon: (props) => (
              <DrawerIcon name={routes.report.name} {...props} />
            ),
          }}
        />
      </DashboardDrawer>
    </LoadingContainer>
  );
});
